module.exports = __webpack_public_path__ + "static/img/01.ec426f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/01.jpg
// module id = bkGR
// module chunks = 1